module.exports = __webpack_public_path__ + "img/mascot-schedule-pickup.38ab023f.svg";